export const aboutObj = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Pantheon Concursos',
  headline: 'Escolha seu concurso',
  description: 'Temos a melhor estrutura de estudos e com aulas, questões e outros.',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/img1.png'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
};

export const discoverObj = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Plataforma de questões',
  headline: 'Filtragem de questões',
  description: 'Seleciona a disciplina e o assunto para estudar.',
  buttonLabel: 'Get started',
  imgStart: true,
  img: require('../../images/img2.png'),
  alt: 'Car',
  dark: false,
  primary: false,
  darkText: true
};

export const signupObj = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'A mais completa',
  headline: 'Plataforma de material',
  description: 'Alem de questões tenha material extra como aulas e conteudo escrito.',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/img3.png'),
  alt: 'svg3',
  dark: false,
  primary: false,
  darkText: true
};